
import Vue from 'vue';
import moment from 'moment';
import Tabs from '@/components/NavTabs/index.vue';
import Tab from '@/components/NavTab/index.vue';
import { StepDataStore } from '@/config/types';
import AlterAddress from './AlterAddress/index.vue';
import AlterPassword from './AlterPassword/index.vue';

import { Wrapper } from './styles';

moment.locale('pt-br');

export default Vue.extend({
  components: {
    Wrapper,
    AlterAddress,
    AlterPassword,
    Tabs,
    Tab,
  },
  inject: ['getStepDate'],

  methods: {
    formatNumber(value: number) {
      return value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
    },
    getStepDate(): StepDataStore {
      return this.$store.state.stepsRegisterTerritoryData;
    },
  },
});
